export default class CurrencyHelper {
	/**
	 * Converts number to currency string.
	 */
	static toCurrency(value: number, withBracketsIfNegative?: boolean): string {
		if (withBracketsIfNegative && value < 0) {
			return `(${CurrencyHelper.toCurrency(Math.abs(value))})`
		}
		return value.toLocaleString("en-IE",
			{style: "currency", currency: "EUR", minimumFractionDigits: 2, maximumFractionDigits: 2});
	}

	/**
	 * Converts pennies to euros in IE locale format.
	 * @param cents
	 */
	static penniesToPounds(cents: number): string {
		return (cents / 100).toLocaleString("en-IE", {style: "currency", currency: "EUR"});
	}

	/**
	 * Checks if string is in 5435345.43 format
	 * @param {string} value
	 * @returns {boolean}
	 */
	static isInCurrencyFormat(value: string): boolean {
		const regexp = /^((\d+(\.\d{0,2})?)|(\.\d{1,2})|(\d+(\.)?))$/;
		return regexp.test(value);
	}
}
